// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_modules_auth_auth_module_ts":"dc4fa242e55866bc","src_app_modules_order-details_order-details_module_ts":"08547fd062830966"}[chunkId] + ".js";
};